import { useState } from "react";
import { Button } from "components/DesignSystem/Button/Button";
import BareInput from "components/DesignSystem/Input/BareInput";
import Modal from "components/DesignSystem/Modal/Modal";
import { useSnoozeChaseItemMutation } from "store/apis/agents";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  companyGroupId: string;
  metricType: string;
  itemUuid: string;
};

export const SnoozeDialog = ({
  isOpen,
  onClose,
  companyGroupId,
  metricType,
  itemUuid,
}: Props) => {
  const [snoozeDays, setSnoozeDays] = useState(3);
  const [snoozeChaseItem, { isLoading }] = useSnoozeChaseItemMutation();

  const handleSnooze = async () => {
    try {
      await snoozeChaseItem({
        company_group_id: companyGroupId,
        metric_type: metricType,
        item_uuid: itemUuid,
        snooze_days: snoozeDays,
      }).unwrap();
      onClose();
    } catch {
      // error surfaced via RTK Query's error state
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={onClose}>
      <Modal.Content size="small">
        <Modal.Header>
          <Modal.Title>Snooze item</Modal.Title>
          <Modal.Subtitle>
            Hide this item from the chase list for a set number of days.
          </Modal.Subtitle>
        </Modal.Header>
        <Modal.Body>
          <BareInput
            label="Snooze for"
            type="number"
            min={1}
            value={snoozeDays}
            onChange={(e) => setSnoozeDays(Math.max(1, Number(e.target.value)))}
            rightComponent={
              <span className="t-text-body-sm t-text-text-60">days</span>
            }
          />
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.Close asChild>
            <Button customType="ghost">Cancel</Button>
          </Modal.Close>
          <Button
            customType="primary"
            onClick={handleSnooze}
            isLoading={isLoading}
            disabled={snoozeDays < 1}
          >
            Snooze
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
